import { render } from "./SecurityEmail.vue?vue&type=template&id=ece21b7c&scoped=true"
import script from "./SecurityEmail.vue?vue&type=script&lang=js"
export * from "./SecurityEmail.vue?vue&type=script&lang=js"

import "./SecurityEmail.vue?vue&type=style&index=0&id=ece21b7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece21b7c"]])

export default __exports__